
import { AudioAds } from '../AudioAds';

export class AudioAdsSite extends AudioAds {

  constructor(props) {
    super(props, { pageForOrgType: 'SITE' })
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/sites/AudioAdsSite.js